export default {"wrapper":"Qr4O5","miniBetslip":"NQLZL","betCount":"p-20G","betAdded":"XwrwP","pulse_animation":"jX73Z","betslipText":"ALVVZ H9fHT UzvkT"};